import * as Yup from "yup";

const OBJECT_ID_REGEX = /^[a-f\d]{24}$/i;

export const getCaseStudyValidationSchema = () =>
  Yup.object({
    title: Yup.string()
      .trim()
      .min(2, "Case study title is required")
      .required("Case study title is required"),

    bulkImages: Yup.array()
      .min(1, "At least one case study image is required")
      .required("Case study images are required"),
  });

export const caseStudyValidationSchema = getCaseStudyValidationSchema();
